module.exports = __webpack_public_path__ + "static/media/DSCF0314-2pqoiYgs.7d102b2f.JPG";